import React, {Component} from "react";
import MaintenanceInstitution from "./MaintenanceInstitutionView";
import {Button} from "primereact/button";
import {InstitutionService} from "../../../service/maintenance/institution/InstitutionService";
import {
    INSERT_INSTITUTION_ROUTE,
    MAINTENANCE_INSTITUTIONS_ROUTE,
    UPDATE_INSTITUTION_ROUTE
} from "../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";

export default class MaintenanceInstitutionContainer extends Component {
    constructor(props) {
        super(props);

        this.institutionService = new InstitutionService();

        this.getInstitutions = this.getInstitutions.bind(this);
        this.exportXLS = this.exportXLS.bind(this);
        this.editInstitutionActionTemplate = this.editInstitutionActionTemplate.bind(this);
        this.editInstitution = this.editInstitution.bind(this);
        this.insertInstitutionScreen = this.insertInstitutionScreen.bind(this);

        this.state = {
            isLoading: true,
            institutionList: [this.getInstitutions()],
        };
    }

    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : ''
            });
        }
    }

    exportXLS() {
        this.loading();
        this.institutionService.exportInstitution().then(response => {
                this.setState({
                    isLoading: false
                });
            }
        );
    }

    getInstitutions() {
        this.loading();
        this.institutionService.getInstitutions().then(
            res => {
                this.setState({
                    isLoading: false,
                    institutionList: res,
                })
            }
        )
    }

    editInstitutionActionTemplate(rowData) {
        return <Button type="button"
                       iconPos="left"
                       label="Editar"
                       style={{marginRight: '.5em'}}
                       onClick={() => this.editInstitution(rowData['idInstitucion'])}
        />;
    }

    editInstitution(institutionId) {
        this.props.history.push({
            pathname: UPDATE_INSTITUTION_ROUTE,
            state: {
                returnPath: MAINTENANCE_INSTITUTIONS_ROUTE,
                institutionId: institutionId,
            },
        });
    }

    insertInstitutionScreen() {
        this.props.history.push({
            pathname: INSERT_INSTITUTION_ROUTE,
            state: {
                returnPath: MAINTENANCE_INSTITUTIONS_ROUTE,
            },
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        return (
            <MaintenanceInstitution
                messagesGrowl={messagesGrowl}
                isLoading={this.state.isLoading}
                insertInstitutionScreen={this.insertInstitutionScreen}
                exportXLS={this.exportXLS}
                editInstitutionActionTemplate={this.editInstitutionActionTemplate}
                institutionList={this.state.institutionList}
                getInstitutions={this.getInstitutions}
            />)
    }
};